// extracted by mini-css-extract-plugin
module.exports = {"actions":"ActionsCellIn_actions_3u_GG","redCrossImage":"ActionsCellIn_redCrossImage_16F68"};